// extracted by mini-css-extract-plugin
export default {"ImageFrame":"ImageFrame-module__ImageFrame___nIeCN","Inverse":"ImageFrame-module__Inverse___2A1eN"};